<style lang="scss" scoped>
@keyframes pulse {
  0% {
    background-color: #fff;
  }
  50% {
    background-color: lighten(#a965a0, 25%);
  }
  100% {
    background-color: #fff;
  }
}

.image {
  height: 45px;
  width: 45px;
}

.dialog-partner {
  cursor: pointer;

  &--selected {
    background-color: #f2f2f2;
  }

  &:hover {
    background-color: lighten(#f2f2f2, 2%);
  }

  &--unread {
    animation: pulse 3s infinite;
  }

  border-bottom: 1px solid #f2f2f2;
}

.dialog-partner__name-wrapper {
  display: flex;
  align-items: center;
  max-width: 100%;
}

.hide-dialog-button {
  position: absolute;
  right: 5px;
  bottom: 5px;
  font-size: 0.7rem;
  color: #6c757d;
  transition: color 0.3s, transform 0.3s;
  background-color: transparent;
  border: none;
  padding: 0;

  &:hover {
    color: $gray-900;
    transform: scale(1.2);
  }

  &:focus {
    box-shadow: none;
  }
}

.last-message-date {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 0.7rem;
}
</style>

<template>
  <div
    class="dialog-partner row"
    :class="{
      'dialog-partner--selected': selected,
      'dialog-partner--unread': hasUnread
    }"
  >
    <div class="col-12">
      <div class="d-flex py-3">
        <div class="pr-3">
          <img v-if="!isDeleted" class="image rounded-circle" :src="imageUrl" />
          <div
            v-else
            class="image rounded-circle bg-light d-flex align-items-center justify-content-center"
          >
            <i class="far fa-times-circle"></i>
          </div>
        </div>
        <div class="flex-grow-1 text-truncate">
          <div class="d-flex flex-column justify-content-around h-100 text-sm">
            <div class="dialog-partner__name-wrapper mr-1">
              <strong class="text-truncate"
                >{{ dialogPartner.name }}
                <span v-if="hasUnread" class="badge badge-primary">{{
                  unreadCount
                }}</span></strong
              >
              <online-circle
                v-if="!isSupport && !isDeleted"
                class="ml-2"
                :id="dialogPartner.id"
              ></online-circle>
            </div>
            <span
              v-if="!isSupport"
              class="d-inline-block text-truncate text-muted mr-1"
            >
              <span v-html="lastMessage.html"></span>
              {{ lastMessage.text }}
            </span>
          </div>
        </div>
      </div>
      <span class="text-muted last-message-date">{{ lastMessageDate }}</span>
      <v-button
        v-if="!isSupport"
        class="hide-dialog-button"
        :working="hidingDialog"
        @click.native.stop="hideDialog"
        title="Dialog verstecken"
      >
        <i class="fas fa-trash-alt"></i>
      </v-button>
    </div>
  </div>
</template>

<script lang="babel">
import OnlineCircle from "@/components/OnlineCircle";
import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    OnlineCircle
  },
  props: {
    dialogPartner: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      hidingDialog: false
    };
  },
  computed: {
    imageUrl() {
      return `${this.dialogPartner.primary_image.url}?"&width=45&height=45`;
    },
    lastMessageDate() {
      let lastMessage = this.dialogPartner.last_message;
      if (!lastMessage) {
        return "";
      }

      const date = moment(lastMessage.created_at);

      if (moment().isSame(date, 'day')) {
        return moment(date).format("HH:mm");
      }

      if (moment().subtract(1, 'days').isSame(date, 'day')) {
        return "Gestern";
      }

      return moment(date).format("DD.MM.YY");
    },
    lastMessage() {
      let lastMessage = this.dialogPartner.last_message;
      if (!lastMessage) {
        return { html: "", text: "" };
      }

      switch (lastMessage.dEType) {
        case "Gif":
          return { html: "<strong>gif</strong>", text: "" };
        case "Geschenk":
          return { html: "<i class=\"fas fa-gifts mr-1\"></i>", text: "Geschenk" };
        case "Bild":
          return { html: "<i class=\"fas fa-camera mr-1\"></i>", text: "Bild" };
        case "Anzwinkern":
          return { html: "", text: Laravel.settings.blinkText };
        case "Freundschafts-Anfrage":
          return { html: "<i class=\"fas fa-user-plus mr-1\"></i>", text: "Freunschaftsanfrage" };
        default:
          return { html: "", text: lastMessage.body };
      }

    },
    isSupport() {
      if(!this.isDeleted)
        return this.dialogPartner.is_support;
      else
        return false;
    },
    isDeleted() {
      return this.dialogPartner.deleted_at;
    },
    hasUnread() {
      return this.unreadCount > 0;
    },
    unreadCount() {
      return this.$store.getters["user/unreadMessages"].filter(unreadMessage => unreadMessage.sender_id === this.dialogPartner.id).length;
    }
  },
  methods: {
    hideDialog() {
      if (this.hidingDialog) {
        return;
      }

      swal.fire({
        title: 'Chat löschen?',
        text: 'Bist du dir sicher, dass du diesen Chat löschen möchtest?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Chat löschen',
        cancelButtonText: 'Abbrechen',
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          this.hidingDialog = true;

          this.$http.post("/api/v1/dialog/hide", {
            partner_id: this.dialogPartner.id
          })
          .then(() => {
            let param = new RegExp('[?&]id=([^&#]*)').exec(window.location.href);
            let chatUserId = Number(param ? param[1] : 0);
            if (chatUserId == this.dialogPartner.id) {
              var newRelativePathQuery = window.location.pathname;
              history.pushState(null, '', newRelativePathQuery);
            }
            location.reload();
            })
            .finally(() => {
              this.hidingDialog = false;
            });

            swal.fire('Saved!', '', 'success')
        } else if (result.isDenied) {
          swal.fire('Changes are not saved', '', 'info')
        }
      });
    }
  }
}
</script>
